import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Text, VStack, Center, Image } from '@chakra-ui/react';
import Logo from '@/assets/images/cyberjob_dialogflow_logo.svg';

const TwoFactorRecoveryPage = () => {
    const { t } = useTranslation('login');
    const navigate = useNavigate();

    return (
        <Center minH="100vh" w="100vw" bg="bg.primary" px={{ base: 4, md: 0 }}>
            <Box w="full" maxW="400px" p={{ base: 6, md: 8 }} bg="bg.secondary" borderRadius={16}>
                <VStack gap={6}>
                    <Image src={Logo} w="70%" mb={2} />
                    <Text fontSize={24} color="white" fontWeight="bold">{t('twoFactorRecoveryPage.title')}</Text>
                    <Text color="text.grey" textAlign="center">
                        {t('twoFactorRecoveryPage.message')}
                    </Text>
                    <Button variant="primary" w="full" onClick={() => navigate('/login')}>
                        {t('twoFactorRecoveryPage.backToLogin')}
                    </Button>
                </VStack>
            </Box>
        </Center>
    );
};

export default TwoFactorRecoveryPage;
